import dayjs from "dayjs";

// K2D "Riportok -> Költségmátrix" (w_popup_report_bokrep 'X' mód) modelljei.

export interface RunCostMatrixParams {
  reportHeadId: number;
  fromDate: string;
  toDate: string;
  isStorno: boolean;
  dimCodeAccum: boolean;
  // K2D "Előző év" rádió: true = Teljes év ('+'), false = Dátum intervallum ('-')
  fullPrevYear: boolean;
}

// K2D d_f_hmboktemprep kezdőértékek: időszak = tárgyhó, koltsegmatrix_ell='+' (a nézetben
// külön kapcsoló), is_dimcode_accum='-', is_storno='-', full_prev_year='+'.
export const DefaultRunCostMatrixParams: RunCostMatrixParams = {
  reportHeadId: 0,
  fromDate: dayjs().startOf("month").format("YYYY-MM-DD"),
  toDate: dayjs().endOf("month").format("YYYY-MM-DD"),
  isStorno: false,
  dimCodeAccum: false,
  fullPrevYear: true,
};

export interface RunCostMatrixResult {
  success: boolean;
  message: string;
  runId: number;
}

// A mátrix egy oszlopa (I. dimenzió kód).
export interface CostMatrixColumn {
  id: number;
  code: string;
  name: string;
}

// A mátrix egy sora; a cells a columns-szal index-igazított.
export interface CostMatrixRow {
  repRowId: number;
  code: string;
  name: string;
  isCode: boolean;
  isBold: boolean;
  isItalic: boolean;
  cells: number[];
  rowTotal: number;
}

export interface CostMatrixResult {
  columns: CostMatrixColumn[];
  rows: CostMatrixRow[];
  columnTotals: number[];
  grandTotal: number;
}
